import { render, staticRenderFns } from "./DocumentPacks.vue?vue&type=template&id=e7c75214&"
import script from "./DocumentPacks.vue?vue&type=script&lang=js&"
export * from "./DocumentPacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports